import { homeStrings } from '../../../../components/StringBundle';

export const options = {
     allOptions : [
    {
      label: homeStrings.greenCoffeeDashboard,
      id: 'gc',
      url: 'https://app.powerbi.com/view?r=eyJrIjoiZTQ4MWMzZjQtNGVkOC00YjcyLTk1ODgtMzU3NjFjNDY1ODBlIiwidCI6IjNlZGYyN2Q0LTIxZjQtNDk1MS1hOGU1LTgxZDcxOWE2OWVjMCJ9',
    },
    {
      label: homeStrings.inventoryStatusDashboard,
      id: 'inventoryStatus',
      url:'https://app.powerbi.com/view?r=eyJrIjoiOWJjYmMyMzEtYzkxYS00NjAxLTlmMjgtYTA2YTA1Nzg0ODFlIiwidCI6IjNlZGYyN2Q0LTIxZjQtNDk1MS1hOGU1LTgxZDcxOWE2OWVjMCJ9',
    },
    // NOTE: home.js selects dashboards by index, so disabled entries must stay
    // as `null` placeholders to keep the indices of the entries below stable.
    null, // [2] salesDashboard (disabled)
    // {
    //   label: homeStrings.salesDashboard,
    //   id: 'sales',
    //   url: 'https://app.powerbi.com/view?r=eyJrIjoiMDdmY2NkZjItNDE3ZC00OTU4LWI0M2QtNjRmZmZiMmJjZWQ4IiwidCI6IjNlZGYyN2Q0LTIxZjQtNDk1MS1hOGU1LTgxZDcxOWE2OWVjMCJ9',
    // },
    {
      label: homeStrings.salesAnalysisDashboard,
      id: 'salesAnalysis',
      url:'https://app.powerbi.com/view?r=eyJrIjoiMGQ2MjNhYjAtZjI5Yy00NGJjLTllOGYtZjk5NmI4NDEyYTkzIiwidCI6IjNlZGYyN2Q0LTIxZjQtNDk1MS1hOGU1LTgxZDcxOWE2OWVjMCJ9',
    },
    null, // [4] capacityCalendarDashboard (disabled)
    // {
    //   label: homeStrings.capacityCalendarDashboard,
    //   id: 'capacity',
    //   url: 'https://app.powerbi.com/view?r=eyJrIjoiNWZkZThlYWItMDM0YS00NTRkLWI2YjEtYjkwNWEwNDg4YzBkIiwidCI6IjNlZGYyN2Q0LTIxZjQtNDk1MS1hOGU1LTgxZDcxOWE2OWVjMCJ9',
    // },
    {
      label: homeStrings.gcAllocationDashboard,
      id: 'gcallocation',
      url: 'https://app.powerbi.com/view?r=eyJrIjoiNmM2NDRhMzYtZTkzOS00MTdiLWI2NTktYjExZDVlNDc5YzE1IiwidCI6IjNlZGYyN2Q0LTIxZjQtNDk1MS1hOGU1LTgxZDcxOWE2OWVjMCJ9',
    },
    {
      label: homeStrings.gcReceiptsDashboard,
      id: 'gcreceipts',
      url: 'https://app.powerbi.com/view?r=eyJrIjoiMTBlNWExZDUtNWQzMi00YTEzLWFlMTAtY2FlZmI3NWJlODJlIiwidCI6IjNlZGYyN2Q0LTIxZjQtNDk1MS1hOGU1LTgxZDcxOWE2OWVjMCJ9',
    },
    {
      label: homeStrings.gcPendingDashboard,
      id: 'gcpending',
      url: 'https://app.powerbi.com/view?r=eyJrIjoiMDJkM2Q3MmYtZTJlNi00YTczLTg5NjItYTk3MzBlMmQ4NzJjIiwidCI6IjNlZGYyN2Q0LTIxZjQtNDk1MS1hOGU1LTgxZDcxOWE2OWVjMCJ9',
    },
    {
      label: homeStrings.gcLogisticsDashboard,
      id: 'gclogistics',
      url: 'https://app.powerbi.com/view?r=eyJrIjoiZWNlODNlMTgtMmU1OC00OTljLTg1MWUtYmMyMjc0MjRmZTFlIiwidCI6IjNlZGYyN2Q0LTIxZjQtNDk1MS1hOGU1LTgxZDcxOWE2OWVjMCJ9',
    },
    null, // [9] executiveDashboard (disabled)
    // {
    //   label: homeStrings.executiveDashboard,
    //   id: 'executive',
    //   url: 'https://app.powerbi.com/view?r=eyJrIjoiNjYzZTY2ZTgtZDkzNi00YWEyLWJlZWYtZTAxN2RlZTA2OWEyIiwidCI6IjNlZGYyN2Q0LTIxZjQtNDk1MS1hOGU1LTgxZDcxOWE2OWVjMCJ9',
    // },
    null, // [10] costAnalysis (disabled)
    // {
    //   label: homeStrings.costAnalysis,
    //   id: 'costanalysis',
    //   url: 'https://app.powerbi.com/view?r=eyJrIjoiZGY4ZTFkYjAtYzRiZS00MzIyLWFmODAtNzZhNDAyYjJiNjRiIiwidCI6IjNlZGYyN2Q0LTIxZjQtNDk1MS1hOGU1LTgxZDcxOWE2OWVjMCJ9',
    // },
    {
      label: homeStrings.purchaseReportTop15Items,
      id: 'purchasereport',
      url: 'https://app.powerbi.com/view?r=eyJrIjoiMWMwZGUyODktMjcyYy00NzE4LWFiZjUtNDg4Nzg3MzViMWI2IiwidCI6IjNlZGYyN2Q0LTIxZjQtNDk1MS1hOGU1LTgxZDcxOWE2OWVjMCJ9',
    },
    {
      label: homeStrings.inventoryAvailableQty,
      id: 'inventoryAvailableQty',
      url: 'https://app.powerbi.com/view?r=eyJrIjoiYTI1OGZhNGYtZmM0Yi00ZWZmLWFkZGEtMTgzODZlMGUzYjRmIiwidCI6IjNlZGYyN2Q0LTIxZjQtNDk1MS1hOGU1LTgxZDcxOWE2OWVjMCJ9',
    },
    {
      label: homeStrings.salesOrderDashboard,
      id: 'salesOrderDashboard',
      url: "https://app.powerbi.com/view?r=eyJrIjoiZmIzYzRkYTctNTY5Ni00NWVlLTg5NDgtYzBkOTVhMzMxMTA0IiwidCI6IjNlZGYyN2Q0LTIxZjQtNDk1MS1hOGU1LTgxZDcxOWE2OWVjMCJ9",
    },
    {
      label: homeStrings.scmDashboard,
      id: 'scmDashboard',
      url: "https://app.powerbi.com/view?r=eyJrIjoiYzk4NTZkZTctYTA1YS00OTY2LTlkNDMtNjgzMWY0YzBkZTFjIiwidCI6IjNlZGYyN2Q0LTIxZjQtNDk1MS1hOGU1LTgxZDcxOWE2OWVjMCJ9",
    },
    {
      label: homeStrings.inventorySummaryReport,
      id: 'inventorySummaryReport',
      url: " https://app.powerbi.com/view?r=eyJrIjoiZWQzMmZmNGItYTM5OC00NWM4LTk4MDctODc4OTk1NjIzMTY5IiwidCI6IjNlZGYyN2Q0LTIxZjQtNDk1MS1hOGU1LTgxZDcxOWE2OWVjMCJ9",
    },
    {
      label: homeStrings.orderDispatchStatusTracker,
      id: 'orderDispatchStatusTracker',
      url: "https://app.powerbi.com/view?r=eyJrIjoiMWYyMDJkYWMtNzEyMy00ZDBhLWI5Y2EtMWFlMTY0MDFlYmE1IiwidCI6IjNlZGYyN2Q0LTIxZjQtNDk1MS1hOGU1LTgxZDcxOWE2OWVjMCJ9",
    },
    {
      label: homeStrings.order_schedule_qty_report,
      id: 'orderScheduleQuantityReport',
      url: "https://app.powerbi.com/view?r=eyJrIjoiMTIzYTQyNGEtMGMyMS00MTRiLTkwN2QtYWIzNDcyZjRjZTBmIiwidCI6IjNlZGYyN2Q0LTIxZjQtNDk1MS1hOGU1LTgxZDcxOWE2OWVjMCJ9",
    },
    {
      label: homeStrings.exportLogisticsDashboard,
      id: 'exportLogisticsDashboard',
      url: "https://app.powerbi.com/view?r=eyJrIjoiOTU3Y2IyMDItZDllMC00NGYyLTg0MjgtZTY2YzczOGZmMDJlIiwidCI6IjNlZGYyN2Q0LTIxZjQtNDk1MS1hOGU1LTgxZDcxOWE2OWVjMCJ9",
    },
    {
      label: homeStrings.gcConsumptionDashboard,
      id: 'gcConsumptionDashboard',
      url: "https://app.powerbi.com/view?r=eyJrIjoiNWE0NThkM2QtZTYxYS00YjFiLTkwNDItNjUyYWEyOWIwOGU4IiwidCI6IjNlZGYyN2Q0LTIxZjQtNDk1MS1hOGU1LTgxZDcxOWE2OWVjMCJ9",
    },
    {
      label: homeStrings.packingMaterialReceiptDashboard,
      id: 'packingMaterialReceiptDashboard',
      url: "https://app.powerbi.com/view?r=eyJrIjoiNmVkM2I3ZDAtZTMyMy00Yjg2LTljYzgtNjE4ODZlN2Q3ZmU3IiwidCI6IjNlZGYyN2Q0LTIxZjQtNDk1MS1hOGU1LTgxZDcxOWE2OWVjMCJ9&disablecdnExpiration=1786395296",
    },
    {
      label: homeStrings.logisticPaymentAndDetailsReport,
      id: 'logisticPaymentAndDetailsReport',
      url: "https://app.powerbi.com/view?r=eyJrIjoiZDFmYjM0MjQtMDFiMi00YjllLWFiODYtNzg5NWFjNWJhMzJkIiwidCI6IjNlZGYyN2Q0LTIxZjQtNDk1MS1hOGU1LTgxZDcxOWE2OWVjMCJ9&pageName=31bd34cec0282010b554%22",
    },
    {
      label: homeStrings.quoteVsAllocateVsConsumedPriceDashboard,
      id: 'quoteVsAllocateVsConsumedPriceDashboard',
      url: "https://app.powerbi.com/view?r=eyJrIjoiMTU0NzdiMTgtY2QzYy00MWVjLTgyNzEtOTkwOTA5Njk1NjZkIiwidCI6IjNlZGYyN2Q0LTIxZjQtNDk1MS1hOGU1LTgxZDcxOWE2OWVjMCJ9&pageName=59203e8c3dc2309de564%22",
    },
    {
      label: homeStrings.gcFinanceBudgetReport,
      id: 'gcFinanceBudgetReport',
      url: "https://app.powerbi.com/view?r=eyJrIjoiYzY2MWMxNWMtMjBjMC00MmYzLTk1NTctNWU1MWUzM2ZlOTcyIiwidCI6IjNlZGYyN2Q0LTIxZjQtNDk1MS1hOGU1LTgxZDcxOWE2OWVjMCJ9",
    },
    {
      label: homeStrings.gcSiloDispensingWorkOrderReport,
      id: 'gcSiloDispensingWorkOrderReport',
      url: "https://app.powerbi.com/view?r=eyJrIjoiMjllYTljYzItM2YwNy00NDA0LTlmYzQtNGM1NDc5M2Q0OTQ0IiwidCI6IjNlZGYyN2Q0LTIxZjQtNDk1MS1hOGU1LTgxZDcxOWE2OWVjMCJ9",
    },
    {
      label: homeStrings.quoteStatusTracker,
      id: 'quoteStatusTracker',
      url: "https://app.powerbi.com/view?r=eyJrIjoiNWU4YWFlMzctZmQyMC00YmE3LWJkNmYtYmNiNzVmMjA5MTNkIiwidCI6IjNlZGYyN2Q0LTIxZjQtNDk1MS1hOGU1LTgxZDcxOWE2OWVjMCJ9",
    },
  ]
}
